import { cleanObject } from '@shared/utils';
import getPieveRuntimeInstanceHeader from '@/lib/apps/getPieveRuntimeInstanceHeader.js';
import { post } from '@/redux/requests/api.js';
import createRequestFailure from '@/redux/requests/lib/createRequestFailure.js';
import normalizeRequestFailure from '@/redux/requests/lib/normalizeRequestFailure.js';
import toValidationFailure from '@/redux/requests/lib/toValidationFailure.js';

const testCompanyCredential = ({ credentialId, appId, appVersion, signal } = {}, callback) => {
  const normalizedCredentialId = String(credentialId || '').trim();
  const normalizedAppId = String(appId || '').trim();
  const normalizedAppVersion = String(appVersion || '').trim();

  if (!normalizedCredentialId) {
    return toValidationFailure('credentialId is required');
  }

  if (!normalizedAppId) {
    return toValidationFailure('appId is required');
  }

  if (!normalizedAppVersion) {
    return toValidationFailure('appVersion is required');
  }

  return post(`/v1/credentials/${encodeURIComponent(normalizedCredentialId)}/test`, {
    action: 'TEST_CREDENTIAL',
    meta: {
      credentialId: normalizedCredentialId
    },
    callback,
    data: cleanObject(
      {
        appId: normalizedAppId,
        appVersion: normalizedAppVersion
      },
      { strict: true }
    ),
    headers: {
      'x-mindcloud-instance': getPieveRuntimeInstanceHeader()
    },
    loader: 'testCompanyCredential',
    signal,
    onResponse: (responseShape) => {
      const nextResponseShape = normalizeRequestFailure({
        responseShape,
        fallbackMessage: 'Failed to test credential'
      });

      if (nextResponseShape?.data?.success !== true) {
        return nextResponseShape;
      }

      const testResult = nextResponseShape?.data?.data || {};

      return {
        ...nextResponseShape,
        data:
          testResult?.success === true
            ? {
                success: true,
                data: testResult,
                requestSuccess: true
              }
            : {
                ...createRequestFailure({
                  message: testResult?.message || 'Failed to test credential',
                  data: testResult
                }),
                requestSuccess: true
              }
      };
    }
  });
};

export default testCompanyCredential;
